import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {AfterCreateGameEvent} from "@/modules/base/events/AfterCreateGameEvent";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {GroundSlot} from "@/modules/club-grounds/entity";
import {EffectTypeEnum, GroundSlotTypeEnum} from "@/modules/club-grounds/enums";
import AggregatedEffectProvider from "@/modules/club-grounds/services/AggregatedEffectProvider";
import {Team} from "@/modules/team/entity";

@injectable()
export class GameCreationEventSubscriber implements EventSubscriber {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
    @inject(AggregatedEffectProvider) private aggregatedEffectProvider: AggregatedEffectProvider,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterCreateGameEvent, callback: this.onAfterCreateGameEvent},
    ];
  }

  async onAfterCreateGameEvent(event: AfterCreateGameEvent): Promise<void> {
    const team = await Team.current();

    await times(this.configRepository.get('clubGrounds.totalSlots'), 0)
      .forEachAsync(async (item: number) => {
        const slot = new GroundSlot;
        slot.price = 1000 * item;

        if (item === 0) {
          slot.type = GroundSlotTypeEnum.OFFICE;
          slot.unlockable = true;
          slot.locked = false;
          slot.available = true;
          slot.demolishable = false;

          const value = this.aggregatedEffectProvider.getSingleValue(EffectTypeEnum.STAFF_MEMBER_SLOTS, slot);

          if (value !== null) {
            team.staffSlots += value;
            await team.save();
          }
        }

        if (item === 1) {
          slot.type = GroundSlotTypeEnum.HEADQUATERS;
          slot.unlockable = true;
          slot.locked = false;
          slot.available = true;
          slot.demolishable = true;
        }

        if (item === 2) {
          slot.unlockable = true;
          slot.locked = false;
          slot.available = true;
        }

        if (item === 3) {
          slot.unlockable = true;
        }

        return slot.save();
      });
  }
}